import { ShieldCheck } from 'lucide-react';

export default function ComplianceNote() {
  return (
    <section className="border-t border-slate-200 bg-white py-8 dark:border-white/10 dark:bg-[#07111f]">
      <div className="container-page">
        <div className="flex gap-4 rounded-2xl border border-slate-200 bg-cloud p-5 text-sm leading-6 text-slate-600 dark:border-white/10 dark:bg-white/[0.04] dark:text-slate-300">
          <ShieldCheck
            size={20}
            className="mt-0.5 shrink-0 text-teal-700 dark:text-teal-300"
            aria-hidden="true"
          />
          <p>
            DropBridge creates editable Shopify product drafts from supplier information selected by
            the merchant. Merchants are responsible for ensuring they have the necessary rights to
            use imported content and for complying with applicable laws and platform policies.
          </p>
        </div>
      </div>
    </section>
  );
}
